package one.healthium.tasks.di

import one.healthium.db.di.appDatabaseModule
import one.healthium.domain.user.UserEvents
import one.healthium.insights.ui.content.ContentEvents
import one.healthium.tasks.data.AppDailyTasksRepository
import one.healthium.tasks.data.mapper.DailyTaskMapper
import one.healthium.tasks.data.storages.TasksInfoStorage
import one.healthium.tasks.domain.DailyTasksRepository
import one.healthium.tasks.domain.TasksCompletionEventsHandler
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.bind
import org.koin.dsl.module

val dailyTasksModule = module {
    includes(appDatabaseModule)
    singleOf(::DailyTaskMapper)

    singleOf(::AppDailyTasksRepository) bind DailyTasksRepository::class
    singleOf(::TasksInfoStorage)

    singleOf(::TasksCompletionEventsHandler) bind ContentEvents::class
}